import React, { Component } from "react";
import Gallery from "react-photo-gallery";
import Lightbox from "react-images";

class PartsGallery extends Component {
  state = {
    currentImage: 0,
    lightboxIsOpen: false
  };

  openLightbox = (e, obj) => {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen: true
    });
  };
  closeLightbox = () => {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false
    });
  };
  gotoPrevious = () => {
    this.setState({
      currentImage: this.state.currentImage - 1
    });
  };
  gotoNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1
    });
  };
  render() {
    return (
      <div className="section">
        <div className="container">
          <Gallery
            // direction="column"
            photos={photos}
            margin={2}
            onClick={this.openLightbox}
          />
          <Lightbox
            images={photos.map(p => p)}
            backdropClosesModal
            onClose={this.closeLightbox}
            onClickPrev={this.gotoPrevious}
            onClickNext={this.gotoNext}
            currentImage={this.state.currentImage}
            isOpen={this.state.lightboxIsOpen}
            width={1600}
          />
        </div>
      </div>
    );
  }
}

const photos = [
  {
    src: require("../../images/gallery/part-05.jpg"),
    width: 4,
    height: 3,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-04.jpg"),
    width: 4,
    height: 3,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-03.jpg"),
    width: 9,
    height: 16,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-06.jpg"),
    width: 16,
    height: 9,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-02.jpg"),
    width: 4,
    height: 3,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-07.jpg"),
    width: 4,
    height: 3,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-01.jpg"),
    width: 9,
    height: 16,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-08.jpg"),
    width: 4,
    height: 3,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-09.jpg"),
    width: 16,
    height: 9,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-10.jpg"),
    width: 4,
    height: 3,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-11.jpg"),
    width: 4,
    height: 3,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-12.jpg"),
    width: 1200,
    height: 675,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-13.jpg"),
    width: 4,
    height: 3,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-14.jpg"),
    width: 4,
    height: 3,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-15.jpg"),
    width: 4,
    height: 3,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-16.jpg"),
    width: 12,
    height: 8,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-17.jpg"),
    width: 12,
    height: 8,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-18.jpg"),
    width: 1200,
    height: 675,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  },
  {
    src: require("../../images/gallery/part-19.jpg"),
    width: 4,
    height: 3,
    alt: "Part Manufactured by Accratronics Seals, LLC."
  }
];

export default PartsGallery;



// WEBPACK FOOTER //
// ./src/pages/Showcase/PartsGallery.js